import { IParamsToSend } from '@base/@types/providers/Kpi/SalesProvider'

export const saleIndicatorsRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: false
  },
  statusEstoque: {
    ids: [],
    agrupar: false
  },
  curvaABC: {
    descricoes: [],
    agrupar: false
  },
  fornecedor: {
    ids: [],
    agrupar: false
  },
  // subCategoria: {
  //   ids: [],
  //   agrupar: false
  // },
  periodo: {
    inicio: new Date().toISOString(),
    final: new Date().toISOString(),
    agrupar: false
  }
}
